import {
  Layout,
  AppBar,
  ToggleThemeButton,
  UserMenu,
  Logout,
  useSidebarState,
} from "react-admin";
import { Box, Typography, Slide, Chip } from "@mui/material";
import { getEnvStyling, setTabTitle } from "../ra-lb-tools/utils/tools";
import { Menu } from "./menu";
import { EnvSwitcher } from "../ra-lb-tools/components/envSwitcher";
import { TimezoneSelect } from "../ra-lb-tools/components/timezoneSelect";
import { InputMonitor } from "../views/misc/inputMonitor";
import { Settings } from "../ra-lb-tools/utils/settings";
import { Store } from "../ra-lb-tools/utils/store";
import get from "lodash/get";
import { WarningAmber } from "@mui/icons-material";
import { useMyContext } from "../ra-lb-tools/components/myContext";
import { darkTheme, jiTheme } from "./theme";
import { AfterPageRendered } from "../ra-lb-tools/components/afterPageRendered";
import { RenderCounter } from "../ra-lb-tools/components/renderCounter";

const Logo = () => {
  const [open] = useSidebarState();

  return (
    <Box className="Logo">
      <Box className="ImgWrapper" style={open ? { display: "none" } : null}>
        <img src="/admin/logo192.png" />
      </Box>
      <Slide direction="right" in={open} mountOnEnter unmountOnExit>
        <Box className="label-wrapper">
          <img src="/admin/harbor-console-logo.png" />
        </Box>
      </Slide>
    </Box>
  );
};

const MyUserMenu = (props) =>
  Settings.debugging() ? <UserMenu {...props} /> : <Logout />;

const CustomBackendWarning = () => {
  const customBackend = get(Store.getAll(), "RaStore.app_settings.ENV.API_URL");

  if (!customBackend) return null;

  return (
    <Chip
      title={customBackend}
      icon={<WarningAmber />}
      label="Custom Backend API !!!"
      color="error"
      sx={{ alignSelf: "center" }}
    />
  );
};

const KeycloakErrorWarning = () => {
  const { keycloakError: error } = useMyContext();

  if (!error) return null;

  return (
    <Chip
      title={error}
      icon={<WarningAmber />}
      label="Keycloak error !!!"
      color="error"
      sx={{ alignSelf: "center" }}
    />
  );
};

const MyAppBar = (props) => {
  const env_styling = getEnvStyling();
  const env_label = env_styling.label && (
    <span style={{ textTransform: "uppercase" }}> ({env_styling.label})</span>
  );
  const env_sx = env_styling.barSx;
  const sx = Settings.debugging() ? {} : { "*": { color: "white" } };

  const sxTitle = {
    display: "flex",
    columnGap: "5px",
    alignItems: "center",
    flex: 1,
  };

  return (
    <AppBar {...props} sx={{ ...env_sx, ...sx }} userMenu={<MyUserMenu />}>
      <Logo />
      <Box className="AppBarTitle" sx={sxTitle}>
        <Typography
          variant="h6"
          id="react-admin-title"
          sx={{ display: "inline-block" }}
        ></Typography>
        {env_label}
        <CustomBackendWarning />
        <KeycloakErrorWarning />
      </Box>
      <TimezoneSelect />
      <EnvSwitcher />
      <ToggleThemeButton lightTheme={jiTheme} darkTheme={darkTheme} />
    </AppBar>
  );
};

const MyLayout = (props) => (
  <InputMonitor className={"LayoutWrapper"}>
    <Layout {...props} appBar={MyAppBar} menu={Menu} />
    <AfterPageRendered onDone={() => setTabTitle("Harbor Admin")} />
    <RenderCounter />
  </InputMonitor>
);

export default MyLayout;
